import React from 'react'
import { observer, inject } from 'mobx-react'
import { withTranslation } from 'react-i18next'
import _ from 'lodash'
import api from 'api.js'
import errorStore from 'stores/ErrorStore'
import { clearToken } from '../../../token'

const openStripePortal = async (userId) => {
  try {
    const { data } = await api.generatePortalLink(userId)

    if (!data || data.success === false || !data.url) {
      const message = _.get(data, 'body.error_message') || _.get(data, 'message') || 'Stripe portal URL missing in response'
      throw new Error(message)
    }

    window.open(data.url, '_self')
  } catch (err) {
    errorStore.error(err)
  }
}

const AccountMenuItems = ({ t, uiStore, onLogout }) => {
  const handleLogOut = () => {
    localStorage.removeItem('leftDrawerSortType')
    clearToken()
    onLogout({ returnTo: process.env.LOGOUT_URL })
  }
  const roleLabelMap = {
    starter: t('GLOBAL.ACC_STARTER'),
    standalone: t('GLOBAL.ACC_SOLO'),
    enterprise_manager: t('GLOBAL.ACC_ENTERPRISE'),
    enterprise_developer: t('GLOBAL.ACC_ENTERPRISE'),
  }

  return (
    <>
      <span className='toolbar__user' onClick={(e) => { e.stopPropagation() }}>{uiStore.user.email}</span>
      <a
        className='toolbar__sublist-btn toolbar__sublist-btn--account'
        href='#'
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          openStripePortal(uiStore.user.id)
        }}
      >
        {t('TOOLBAR.ACCOUNT')}
        <span
          className={`toolbar__user-type toolbar__user-type--${uiStore.user.type}`}
        >
          {roleLabelMap[uiStore.user.type]
            ? roleLabelMap[uiStore.user.type]
            : t('GLOBAL.ACCOUNT')}
        </span>
      </a>
      <button type='button' className='toolbar__sublist-btn' onClick={handleLogOut}>
        {t('GLOBAL.LOG_OUT')}
      </button>
    </>
  )
}

export default withTranslation()(inject('uiStore')(observer(AccountMenuItems)))
